export const unique = (value, values, message = 'Значение не должно повторяться') => {
    if (false || values.filter(v => v === value).length > 1) {
        return message;
    }
    return null;
};
